/**
 * Resolves the role-specific day prefix for tasks and attendance.
 *
 * Rules:
 * - If user's role is 'Developer' or position contains 'developer' -> "Developer"
 * - If user's role is 'Employee' -> "Employee"
 * - If user's role is 'Intern' or 'Internee' -> "Internee"
 * - For other known roles (e.g., Designer, Manager, Team Lead) -> role name
 * - Default fallback -> "Internee"
 */
export const getRoleDayPrefix = (userData) => {
  let user = userData;
  if (!user) {
    try {
      user = JSON.parse(localStorage.getItem('portalUser')) || {};
    } catch (e) {
      user = {};
    }
  }

  const role = user?.role || '';
  const position = (user?.position || '').toLowerCase();
  const lowerRole = role.toLowerCase();

  if (lowerRole === 'developer' || position.includes('developer')) {
    return 'Developer';
  }
  if (lowerRole === 'employee') {
    return 'Employee';
  }
  if (lowerRole === 'intern' || lowerRole === 'internee') {
    return 'Internee';
  }
  if (lowerRole === 'designer' || position.includes('designer')) {
    return 'Designer';
  }
  if (role && role !== 'Admin') {
    return role;
  }
  return 'Internee';
};

/**
 * Formats the day label string, e.g.:
 * - "Internee Day 3"
 * - "Employee Day 5"
 * - "Developer Day 2"
 */
export const formatRoleDay = (userData, dayNumber) => {
  if (!dayNumber && dayNumber !== 0) return "Today's Agenda";
  const prefix = getRoleDayPrefix(userData);
  return `${prefix} Day ${dayNumber}`;
};
